import React, { useRef, useState } from "react";

import ReactToPrint from "react-to-print";

import { Flex, Spinner, Text, Box, Divider } from "@chakra-ui/react";

import RelatorioService from "../../../main/services/RelatorioService";
import { FaFilePdf } from "react-icons/fa";
import { ComponentToPrintRelatorioCrianca } from "../ComponentToPrintRelatorioCrianca";
import {
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../helpers/Funcionalidades";

export const PrintButtonRelatorioCrianca = ({
  user,
  token,
  entidade,
  dados,
  roleKeycloack,
}) => {
  const componentToPrintRef = useRef(null);
  const [dataPendencias, setDataPendencias] = useState([]);
  const [columnsPendencias, setColumnsPendencias] = useState([]);
  const [loading, setLoading] = useState(false);
  const tempObj = JSON.parse(sessionStorage.getItem("table-" + entidade));
  const storage = JSON.parse(sessionStorage.getItem(entidade + "-filter"));

  const formatarData = (data) => {
    if (!data) return "";
    if (data.includes("/")) {
      const [dia, mes, ano] = data.split("/");
      return `${ano}-${mes}-${dia}`;
    }
    return data;
  };

  const beforeGetContent = async () => {
    setLoading(true);
    try {
      const idsServicoAcolhimentoChange = roleKeycloack.includes(
        criancaFunc.visualizarTudoAcolhimento,
      )
        ? [storage?.idsServicosAcolhimento.value]
        : Array.isArray(storage?.idsServicosAcolhimento)
        ? storage?.idsServicosAcolhimento
            .flat()
            .map((item) => item.value)
            .filter((value) => value !== "")
        : [];

      const valuesToSend = {
        universoConsulta: storage?.universoConsulta
          ? storage?.universoConsulta?.label
              ?.normalize("NFD")
              ?.replace(/[\u0300-\u036f]/g, "")
              ?.toUpperCase()
          : "",
        idsServicosAcolhimento: storage?.idsServicosAcolhimento
          ? idsServicoAcolhimentoChange
          : [],
        dataInicio: storage?.dataInicio ? formatarData(storage.dataInicio) : "",
        dataFim: storage?.dataFim ? formatarData(storage.dataFim) : "",
        idsMotivosEntrada: storage?.idsMotivosEntrada
          ? storage?.idsMotivosEntrada
              .flat()
              .map((item) => item.id)
              .filter((id) => id !== "")
          : [],
        idTipoTransferencia: storage?.idTipoTransferencia
          ? storage?.idTipoTransferencia.id
          : "",
        idJustificativas: storage?.idJustificativas
          ? storage?.idJustificativas
              .flat()
              .map((item) => item.id)
              .filter((id) => id !== "")
          : [],
        tipoPeriodo: storage?.tipoPeriodo === "A" ? "SITUACAO_ATUAL" : "DATA",
        entradasPorTransferencias:
          Array.isArray(storage?.entradasPorTransferencias) &&
          storage.entradasPorTransferencias.includes("Possui"),

        maioresDezoito:
          Array.isArray(storage?.maioresDezoito) &&
          storage.maioresDezoito.includes("Possui"),
        saidaTransferencia:
          Array.isArray(storage?.saidaTransferencia) &&
          storage.saidaTransferencia.includes("Possui"),
        pageSize: 9999999,
        page: 0,
        sortField: tempObj ? tempObj[0]?.id : "nomeCrianca",
        sortType: tempObj ? (tempObj[0]?.desc ? "DESC" : "ASC") : "ASC",
      };

      const res = await RelatorioService.getRelatorioCrianca(
        token,
        valuesToSend,
      );

      if (res?.data) {
        setColumnsPendencias([
          {
            Header: "Nome/Nome Social",
            accessor: "nomeCrianca",
            Cell: (props) => {
              let name = props?.row?.original?.nomeCrianca;
              const descricaoTipoSituacao =
                props?.row?.original?.descricaoTipoSituacao;
              const temRiscoVida =
                props?.row?.original?.riscoVida === "S" ? true : false;
              const idMovimento = props?.row?.original?.idMovimento;

              if (props?.row?.original?.nomeSocial) {
                name = name + " / " + props.row.original.nomeSocial;
              }

              return (roleKeycloack &&
                roleKeycloack.includes(criancaFunc.visualizar)) ||
                roleKeycloack.includes(
                  servicoAcolhimentoFunc.visualizarPartePPCAAM,
                ) ? (
                !temRiscoVida ? (
                  <Box wordBreak={"break-word"}>
                    <Flex alignItems="center" gap={2}>
                      {descricaoTipoSituacao === "Acolhido" &&
                      idMovimento === 2 ? (
                        <Box
                          w="4"
                          h="4"
                          bg="#169499"
                          borderRadius="full"
                          border="1px"
                          color="#169499"
                        />
                      ) : descricaoTipoSituacao === "Acolhido" ||
                        descricaoTipoSituacao === "Desligado" ? (
                        <Box w="3" h="3" borderRadius="full" />
                      ) : (
                        <Box
                          w="4"
                          h="4"
                          bg="red"
                          borderRadius="full"
                          border="1px"
                          color="red"
                        />
                      )}
                      <Text
                        display="flex"
                        minH={"40px"}
                        alignItems={"center"}
                        minWidth="250px"
                      >
                        {name}
                      </Text>
                    </Flex>
                  </Box>
                ) : (
                  <Box wordBreak={"break-word"}>
                    <Flex alignItems="center" gap={2}>
                      {descricaoTipoSituacao === "Acolhido" &&
                      idMovimento === 2 ? (
                        <Box
                          w="4"
                          h="4"
                          bg="#169499"
                          borderRadius="full"
                          border="1px"
                          color="#169499"
                        />
                      ) : descricaoTipoSituacao === "Acolhido" ||
                        descricaoTipoSituacao === "Desligado" ? (
                        <Box w="3" h="3" borderRadius="full" />
                      ) : (
                        <Box
                          w="4"
                          h="4"
                          bg="red"
                          borderRadius="full"
                          border="1px"
                          color="red"
                        />
                      )}
                      <Text
                        display="flex"
                        minH={"40px"}
                        alignItems={"center"}
                        minWidth="250px"
                      >
                        {name}
                      </Text>
                    </Flex>
                  </Box>
                )
              ) : !temRiscoVida ? (
                <Flex alignItems="center" gap={2}>
                  {descricaoTipoSituacao === "Acolhido" ||
                  descricaoTipoSituacao === "Desligado" ? (
                    <Box w="3" h="3" borderRadius="full" />
                  ) : (
                    <Box
                      w="3"
                      h="3"
                      bg="red"
                      borderRadius="full"
                      border="1px"
                      color="red"
                    />
                  )}
                  <Text
                    display="flex"
                    h={"40px"}
                    alignItems={"center"}
                    minWidth="250px"
                  >
                    {name}
                  </Text>
                </Flex>
              ) : (
                <Flex alignItems="center" gap={2}>
                  {descricaoTipoSituacao === "Acolhido" ||
                  descricaoTipoSituacao === "Desligado" ? (
                    <Box w="3" h="3" borderRadius="full" />
                  ) : (
                    <Box
                      w="3"
                      h="3"
                      bg="red"
                      borderRadius="full"
                      border="1px"
                      color="red"
                    />
                  )}
                  <Text
                    display="flex"
                    h={"40px"}
                    alignItems={"center"}
                    minWidth="250px"
                  >
                    {name}
                  </Text>
                </Flex>
              );
            },
          },
          {
            Header: "Gênero",
            accessor: "genero",
            Cell: (props) => {
              return <span>{props.value}</span>;
            },
          },
          {
            Header: "Data de Nascimento",
            accessor: "dataNascimento",

            Cell: (props) => {
              return <span>{props.value}</span>;
            },
          },

          {
            Header: "Idade",
            accessor: "idade",
            Cell: (props) => {
              return <Text>{props.value ?? ""}</Text>;
            },
          },
          {
            Header: "Filiação",
            accessor: "filiacoes",
            sortType: (rowA, rowB, id, desc) => {
              const filiacoesA = rowA?.original?.filiacoes?.length
                ? rowA.original.filiacoes
                    .map((filiacao) => filiacao?.filiacao?.nome || "")
                    .reduce((prev, filiacao) => prev + filiacao, "")
                : "";
              const filiacoesB = rowB?.original?.filiacoes?.length
                ? rowB.original.filiacoes
                    .map((filiacao) => filiacao?.filiacao?.nome || "")
                    .reduce((prev, filiacao) => prev + filiacao, "")
                : "";
              return filiacoesA.localeCompare(filiacoesB, "pt-BR");
            },
            Cell: (props) => {
              return props?.value
                .sort((a, b) =>
                  a.descricaoTipoRelacionamento.localeCompare(
                    b.descricaoTipoRelacionamento,
                  ),
                )
                .map((filiacao, index) => {
                  return (
                    <React.Fragment key={index}>
                      <span style={{ whiteSpace: "normal" }}>
                        {filiacao?.nome}{" "}
                        <Text as="span" textTransform="capitalize">
                          ({filiacao?.descricaoTipoRelacionamento.toLowerCase()}
                          )
                        </Text>
                      </span>
                      {props.value.length - 1 !== index && (
                        <>
                          <br />{" "}
                          <Divider
                            borderColor="#DDEBEA"
                            orientation="horizontal"
                            h="2px"
                          />
                        </>
                      )}
                    </React.Fragment>
                  );
                });
            },
          },
          {
            Header: "Serviço de Acolhimento Atual",
            accessor: "servicoAcolhimentoAtual",
            sortType: (rowA, rowB, id, desc) => {
              const nomeServicoA = rowA?.original?.servicoAcolhimentoAtual
                ? rowA.original.servicoAcolhimentoAtual.nomeFantasia
                : "";
              const nomeServicoB = rowB?.original?.servicoAcolhimentoAtual
                ? rowB.original.servicoAcolhimentoAtual.nomeFantasia
                : "";
              return nomeServicoA?.localeCompare(nomeServicoB, "pt-BR");
            },
            Cell: (props) => {
              const permissaoServico =
                roleKeycloack.includes(criancaFunc.visualizarTudo) ||
                roleKeycloack.includes(
                  servicoAcolhimentoFunc.visualizarPartePPCAAM,
                ) ||
                roleKeycloack.includes(
                  servicoAcolhimentoFunc.visualizarParteMP,
                ) ||
                roleKeycloack.includes(
                  servicoAcolhimentoFunc.visualizarParteTJ,
                ) ||
                ((roleKeycloack.includes(
                  criancaFunc.visualizarTudoAcolhimento,
                ) ||
                  roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
                  user?.orgaoExterno?.includes(
                    props?.row?.original?.servicoAcolhimentoAtual
                      ?.idPessoaJuridica,
                  ));
              const temRiscoVida =
                props?.row?.original?.riscoVida === "S" ? true : false;

              if (temRiscoVida && !permissaoServico) {
                return <span></span>;
              } else {
                const idServico =
                  props?.row?.original?.servicoAcolhimentoAtual?.id;
                if (!idServico) {
                  return <span></span>;
                } else {
                  return (
                    <>
                      {roleKeycloack &&
                      roleKeycloack.includes(
                        servicoAcolhimentoFunc.visualizar,
                      ) ? (
                        <Box
                          wordBreak={"break-word"}
                          title={
                            props?.value
                              ? props?.value?.nomeFantasia +
                                `${
                                  props?.value?.suspenso === "S"
                                    ? " (Suspenso)"
                                    : ""
                                }`
                              : ""
                          }
                        >
                          <Text>
                            {" "}
                            {props?.value
                              ? props?.value?.nomeFantasia +
                                `${
                                  props?.value?.suspenso === "S"
                                    ? " (Suspenso)"
                                    : ""
                                }`
                              : ""}
                          </Text>
                        </Box>
                      ) : (
                        <Text>
                          {props?.value
                            ? props?.value?.nomeFantasia +
                              `${
                                props?.value?.suspenso === "S"
                                  ? " (Suspenso)"
                                  : ""
                              }`
                            : ""}
                        </Text>
                      )}
                    </>
                  );
                }
              }
            },
          },
        ]);
      }

      setDataPendencias(res?.data?.content);

      setLoading(false);
    } catch (erro) {
      console.log("Erro ao acessar os dados de impressao");
      console.log(erro);
      setLoading(false);
    }
  };

  const customPageStyle = `
    @page {
      margin: 0mm;
      size: auto;  
      margin-top: 0mm; 
      margin-bottom: 12mm; 
    } 
    @media print { 
      body { 
        -webkit-print-color-adjust: exact; 
      } 
    }
  `;

  return (
    <>
      <ReactToPrint
        onBeforeGetContent={beforeGetContent}
        onAfterPrint={() => setLoading(false)}
        pageStyle={customPageStyle}
        documentTitle={`MCA - Relatório de Crianças e Adolescentes`}
        trigger={() => {
          return loading ? (
            <Spinner size="sm" />
          ) : (
            <Flex
              alignItems="center"
              gap={2}
              cursor="pointer"
              onClick={() => alert("imprimir PDF")}
            >
              <Flex bg="red" rounded="full" p={1}>
                <FaFilePdf color="white" />
              </Flex>

              <Text as="b" color="red" fontSize={"md"}>
                Exportar em PDF
              </Text>
            </Flex>
          );
        }}
        content={() => componentToPrintRef.current}
      />
      <div style={{ display: "none" }}>
        <ComponentToPrintRelatorioCrianca
          ref={componentToPrintRef}
          dataPendencias={dataPendencias ? dataPendencias : null}
          columnsPendencias={columnsPendencias}
          roleKeycloack={roleKeycloack}
          dados={dados}
          user={user}
          storage={storage}
        />
      </div>
    </>
  );
};
